import React, { useEffect, useState } from 'react'
import "./PropertyDetails.css"
import { CreateOrder, getGalleries, getProperties, VerifyPayment } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'

const propertyDummy = {
  id: 10,
  owner_id: null,
  property_name: "Dream Nest Apartments",
  property_type: "apartment",
  description: "Family-friendly apartments with security",
  address: "Garia Main Road",
  city: "Kolkata",
  state: "West Bengal",
  country: "India",
  pincode: "700084",
  total_units: 1,
  available_units: 1,
  rent_amount: "22000.00",
  security_deposit: "44000.00",
  furnishing_status: "furnished",
  status: "available",
  created_at: "2026-04-08 11:52:07",
}

const images = [
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=900&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=900&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=900&auto=format&fit=crop",
]

const amenities = [
  { icon: "🛡️", label: "24/7 Security" },
  { icon: "🅿️", label: "Parking" },
  { icon: "🏋️", label: "Gym" },
  { icon: "🌿", label: "Garden" },
  { icon: "🔧", label: "Maintenance" },
  { icon: "💡", label: "Power Backup" },
  { icon: "🌊", label: "Water Supply" },
  { icon: "📶", label: "Wi-Fi Ready" },
]

const reviews = [
  {
    name: "Priya Sharma",
    initials: "PS",
    rating: 5,
    date: "March 2026",
    text: "Absolutely love this apartment! The security is top-notch and the neighbourhood is peaceful. Maintenance team responds within hours. Highly recommend for families.",
  },
  {
    name: "Arjun Mehta",
    initials: "AM",
    rating: 4,
    date: "February 2026",
    text: "Great location on Garia Main Road — very accessible. The furnishings are modern and well-maintained. Only minor issue is parking can get tight on weekends.",
  },
  {
    name: "Sneha Roy",
    initials: "SR",
    rating: 5,
    date: "January 2026",
    text: "Moved in three months ago and couldn't be happier. Spacious rooms, excellent ventilation, and the building management is very professional and responsive.",
  },
]

const IconLocation = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21C12 21 5 13.5 5 8.5a7 7 0 0 1 14 0c0 5-7 12.5-7 12.5Z"/>
    <circle cx="12" cy="8.5" r="2.5"/>
  </svg>
)
const IconBed = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9V19M21 9V19M3 13h18M3 9a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3"/>
    <path d="M7 13V9h4v4M13 13V9h4v4"/>
  </svg>
)
const IconRupee = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 4h12M6 9h12M12 9l-6 11M6 9a5 5 0 0 0 5 5"/>
  </svg>
)
const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <path d="m9 12 2 2 4-4"/>
  </svg>
)
const IconStar = ({ filled }) => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill={filled ? "#C9962A" : "none"} stroke="#C9962A" strokeWidth="1.5">
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/>
  </svg>
)
const IconHeart = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
)
const IconShare = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <path d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49"/>
  </svg>
)
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/>
  </svg>
)

const Stars = ({ n }) => Array.from({ length: 5 }).map((_, i) => <IconStar key={i} filled={i < n} />)

const formatINR = (val) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(val))

export default function PropertyDetail() {
  const [activeImg, setActiveImg] = useState(0)
  const [wishlisted, setWishlisted] = useState(false)
  const [property,setProperty]=useState(propertyDummy)
  const id=useParams()

    const[properties,setProperties]=useState([])
    const navigate = useNavigate();
    const { isAuthenticated,token} = useSelector((state) => state.auth);
  
    const handleGetProperties=async()=>{
     try {
      const res=await getProperties()
      console.log('getProperties',res,id);
      if(res.status===200){
       // setProperties(res.data.data)
  const item=res.data.data.filter(i=>i.id===Number(id.id))
  console.log("details",item);
  
  setProperty(item[0])
      }
      
     } catch (error) {
      console.log(error);
      
     }
    }
  
      const handleGetGalleries=async()=>{
     try {
      const res=await getGalleries()
      console.log('getGalleries',res);
      
     } catch (error) {
      console.log(error);
      
     }
    }
  
    useEffect(() => {
      handleGetProperties()
    }, [])

     const handleCreateOrder=async()=>{
    try {
        if(!token){
     toast.warning("Unauthorized login first")
        navigate("/login")
  }
     let data={
      property_id:Number(id.id)
      }
      console.log(token);
      
      const res=await CreateOrder(data,token)
      console.log(res);
      if(res.status===200){
        toast.success("Order booked")
        handlePayment(res.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }


        const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const verifyPayment=async(data)=>{
try {
  if(!token){
     toast.warning("Unauthorized login first")
        navigate("/login")
  }
  console.log(data);
  const res= await VerifyPayment(data,token)
  console.log(res);
  if(res.status===200){
    toast.success(
"Payment successful & property booked")
  }
  
  
} catch (error) {
  console.log(error);
  
}
}


  const handlePayment = async (data) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load");
      return;
    }

    // Call your backend to create order
    // const data = await fetch("/api/create-order", {
    //   method: "POST",
    // }).then((t) => t.json());

    const options = {
      key: data.key, // from Razorpay dashboard
      amount: data.amount,
      currency: "INR",
      name: "Siance Software",
      description: "Test Transaction",
      order_id: data.order_id,

      handler: function (response) {
        console.log("Payment Success:", response);
         verifyPayment(response)
        // send this response to backend for verification
        // response.razorpay_payment_id
        // response.razorpay_order_id
        // response.razorpay_signature
      },
 
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9999999999",
      },

      theme: {
        color: "#3399cc",
      },
    };

   

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };
  

  if(!property){

    return(
     
<div className="pd-root pd-skeleton-root">

  {/* HERO GALLERY */}
  <section className="pd-gallery">
    <div className="pd-gallery-main pd-skeleton-box shimmer" />

    <div className="pd-gallery-thumbs">
      {[1,2,3,4].map(i => (
        <div key={i} className="pd-thumb shimmer pd-skeleton-box" />
      ))}
    </div>
  </section>

  {/* MAIN CONTENT */}
  <div className="pd-content">

    {/* LEFT */}
    <div className="pd-left">

      {/* Title Block */}
      <div className="pd-title-block">
        <div className="pd-skeleton-pill shimmer" />
        <div className="pd-skeleton-title shimmer" />
        <div className="pd-skeleton-line shimmer w-60" />
        <div className="pd-skeleton-line shimmer w-40" />
      </div>

      {/* Stats */}
      <div className="pd-stats-grid">
        {[1,2,3,4].map(i => (
          <div key={i} className="pd-stat">
            <div className="pd-skeleton-label shimmer" />
            <div className="pd-skeleton-value shimmer" />
          </div>
        ))}
      </div>

      {/* Description */}
      <div className="pd-section">
        <div className="pd-skeleton-section-title shimmer" />

        <div className="pd-skeleton-para">
          <div className="pd-skeleton-line shimmer" />
          <div className="pd-skeleton-line shimmer" />
          <div className="pd-skeleton-line shimmer w-90" />
        </div>

        <div className="pd-skeleton-para">
          <div className="pd-skeleton-line shimmer" />
          <div className="pd-skeleton-line shimmer" />
          <div className="pd-skeleton-line shimmer w-70" />
        </div>
      </div>

      {/* Amenities */}
      <div className="pd-section">
        <div className="pd-skeleton-section-title shimmer" />

        <div className="pd-amenities">
          {[1,2,3,4,5,6,7,8].map(i => (
            <div key={i} className="pd-amenity">
              <div className="pd-skeleton-icon shimmer" />
              <div className="pd-skeleton-small shimmer" />
            </div>
          ))}
        </div>
      </div>

      {/* Location */}
      <div className="pd-section">
        <div className="pd-skeleton-section-title shimmer" />

        <div className="pd-location-card">
          <div className="pd-skeleton-map shimmer" />

          <div className="pd-location-details">
            {[1,2,3,4,5].map(i => (
              <div key={i} className="pd-loc-row">
                <div className="pd-skeleton-small shimmer w-20" />
                <div className="pd-skeleton-small shimmer w-40" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Reviews */}
      <div className="pd-section">
        <div className="pd-skeleton-section-title shimmer" />

        <div className="pd-reviews">
          {[1,2].map(i => (
            <div key={i} className="pd-review">
              <div className="pd-review-header">
                <div className="pd-skeleton-avatar shimmer" />

                <div style={{flex:1}}>
                  <div className="pd-skeleton-small shimmer w-30 mb-8" />
                  <div className="pd-skeleton-small shimmer w-20" />
                </div>

                <div className="pd-skeleton-small shimmer w-20" />
              </div>

              <div className="pd-skeleton-line shimmer" />
              <div className="pd-skeleton-line shimmer" />
              <div className="pd-skeleton-line shimmer w-80" />
            </div>
          ))}
        </div>
      </div>

    </div>

    {/* RIGHT SIDEBAR */}
    <div className="pd-right">

      <div className="pd-pricing-card">

        <div className="pd-skeleton-price shimmer" />

        <div className="pd-skeleton-bar shimmer" />

        <div className="pd-price-divider" />

        {[1,2,3].map(i => (
          <div key={i} className="pd-price-row">
            <div className="pd-skeleton-small shimmer w-30" />
            <div className="pd-skeleton-small shimmer w-20" />
          </div>
        ))}

        <div className="pd-price-divider" />

        <div className="pd-skeleton-btn shimmer" />
        <div className="pd-skeleton-btn secondary shimmer" />

      </div>

      <div className="pd-trust-card">
        {[1,2,3].map(i => (
          <div key={i} className="pd-trust-row">
            <div className="pd-skeleton-icon shimmer" />
            <div style={{flex:1}}>
              <div className="pd-skeleton-small shimmer w-40 mb-8" />
              <div className="pd-skeleton-small shimmer w-60" />
            </div>
          </div>
        ))}
      </div>

    </div>

  </div>
</div>
    )
  }

  return (
    <div className="pd-root">

      {/* ── NAV BAR ── */}
      

      {/* ── HERO IMAGE GALLERY ── */}
      <section className="pd-gallery">
        <div className="pd-gallery-main">
          <img src={images[activeImg]} alt="property" className="pd-gallery-hero" />
          <div className="pd-gallery-overlay">
            <span className={`pd-badge pd-badge--${property.status}`}>
              {property.status === "available" ? "✦ Available Now" : "Unavailable"}
            </span>
            <div className="pd-gallery-actions">
              <button className={`pd-icon-btn ${wishlisted ? 'active' : ''}`} onClick={() => setWishlisted(v => !v)} title="Wishlist">
                <IconHeart />
              </button>
              <button className="pd-icon-btn" title="Share"><IconShare /></button>
            </div>
          </div>
        </div>
        <div className="pd-gallery-thumbs">
          {images.map((src, i) => (
            <button
              key={i}
              className={`pd-thumb ${activeImg === i ? 'pd-thumb--active' : ''}`}
              onClick={() => setActiveImg(i)}
            >
              <img src={src} alt={`view ${i + 1}`} />
            </button>
          ))}
        </div>
      </section>

      {/* ── MAIN CONTENT ── */}
      <div className="pd-content">

        {/* ── LEFT COLUMN ── */}
        <div className="pd-left">

          {/* Title block */}
          <div className="pd-title-block">
            <div className="pd-type-pill">{property.property_type}</div>
            <h1 className="pd-title">{property.property_name}</h1>
            <div className="pd-location">
              <span className="pd-location-icon"><IconLocation /></span>
              {property.address}, {property.city}, {property.state} — {property.pincode}
            </div>
            <div className="pd-rating-row">
              <div className="pd-stars"><Stars n={4} /></div>
              <span className="pd-rating-count">4.6 · 3 reviews</span>
              <span className="pd-dot">·</span>
              <span className="pd-unit-tag">
                <IconBed /> {property.available_units} unit available
              </span>
            </div>
          </div>

          {/* Quick stats */}
          <div className="pd-stats-grid">
            <div className="pd-stat">
              <span className="pd-stat-label">Furnishing</span>
              <span className="pd-stat-value pd-stat-value--cap">{property.furnishing_status}</span>
            </div>
            <div className="pd-stat">
              <span className="pd-stat-label">Property Type</span>
              <span className="pd-stat-value pd-stat-value--cap">{property.property_type}</span>
            </div>
            <div className="pd-stat">
              <span className="pd-stat-label">Total Units</span>
              <span className="pd-stat-value">{property.total_units}</span>
            </div>
            <div className="pd-stat">
              <span className="pd-stat-label">Listed On</span>
              <span className="pd-stat-value">Apr 2026</span>
            </div>
          </div>

          {/* Description */}
          <div className="pd-section">
            <h2 className="pd-section-title">About this property</h2>
            <p className="pd-desc">
              Welcome to <strong>Dream Nest Apartments</strong> — a thoughtfully designed residential complex nestled in the heart of Garia, South Kolkata. Built for modern families who value comfort, safety, and community, this fully furnished apartment offers a rare blend of urban convenience and peaceful living.
            </p>
            <p className="pd-desc">
              Each unit is finished with premium fittings, ample natural light, and cross-ventilation. The building features round-the-clock security personnel, CCTV surveillance, a power backup generator, and a dedicated maintenance team ensuring zero downtime for residents.
            </p>
            <p className="pd-desc">
              Located right on Garia Main Road, residents enjoy easy access to metro stations, reputed schools, hospitals, shopping malls, and major IT corridors. Ideal for working professionals and families alike.
            </p>
          </div>

          {/* Amenities */}
          <div className="pd-section">
            <h2 className="pd-section-title">Amenities</h2>
            <div className="pd-amenities">
              {amenities.map((a, i) => (
                <div className="pd-amenity" key={i}>
                  <span className="pd-amenity-icon">{a.icon}</span>
                  <span className="pd-amenity-label">{a.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Location detail */}
          <div className="pd-section">
            <h2 className="pd-section-title">Location</h2>
            <div className="pd-location-card">
              <div className="pd-location-map-mock">
                <div className="pd-map-pin">
                  <IconLocation />
                </div>
                <p className="pd-map-label">{property.address}, {property.city}</p>
              </div>
              <div className="pd-location-details">
                <div className="pd-loc-row"><span>Address</span><span>{property.address}</span></div>
                <div className="pd-loc-row"><span>City</span><span>{property.city}</span></div>
                <div className="pd-loc-row"><span>State</span><span>{property.state}</span></div>
                <div className="pd-loc-row"><span>Pincode</span><span>{property.pincode}</span></div>
                <div className="pd-loc-row"><span>Country</span><span>{property.country}</span></div>
              </div>
            </div>
          </div>

          {/* Reviews */}
          <div className="pd-section">
            <h2 className="pd-section-title">Resident Reviews</h2>
            <div className="pd-reviews">
              {reviews.map((r, i) => (
                <div className="pd-review" key={i}>
                  <div className="pd-review-header">
                    <div className="pd-avatar">{r.initials}</div>
                    <div>
                      <div className="pd-reviewer-name">{r.name}</div>
                      <div className="pd-reviewer-date">{r.date}</div>
                    </div>
                    <div className="pd-review-stars"><Stars n={r.rating} /></div>
                  </div>
                  <p className="pd-review-text">{r.text}</p>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* ── RIGHT STICKY SIDEBAR ── */}
        <div className="pd-right">
          <div className="pd-pricing-card">
            <div className="pd-price-shimmer" />

            <div className="pd-price-main">
              <span className="pd-rupee-icon"><IconRupee /></span>
              <span className="pd-price-amount">{formatINR(property.rent_amount)}</span>
              <span className="pd-price-per">/month</span>
            </div>

            <div className="pd-deposit-row">
              <span className="pd-deposit-icon"><IconShield /></span>
              Security deposit: <strong>{formatINR(property.security_deposit)}</strong>
            </div>

            <div className="pd-price-divider" />

            <div className="pd-price-details">
              <div className="pd-price-row">
                <span>Furnishing</span>
                <span className="pd-pill pd-pill--gold">{property.furnishing_status}</span>
              </div>
              <div className="pd-price-row">
                <span>Status</span>
                <span className="pd-pill pd-pill--green">Available</span>
              </div>
              <div className="pd-price-row">
                <span>Units left</span>
                <span>{property.available_units} of {property.total_units}</span>
              </div>
            </div>

            <div className="pd-price-divider" />

            <button className="pd-cta-primary" onClick={()=>handleCreateOrder()}>
              Rent property
            </button>
            <button className="pd-cta-secondary"onClick={()=>alert("Comming soon")}>
              <IconCall /> Contact Owner
            </button>

            <p className="pd-cta-note">Free consultation · No brokerage</p>
          </div>

          {/* Mini trust card */}
          <div className="pd-trust-card">
            <div className="pd-trust-row">
              <span>🏆</span>
              <div>
                <div className="pd-trust-title">Verified Property</div>
                <div className="pd-trust-sub">Documents checked by NestFinder</div>
              </div>
            </div>
            <div className="pd-trust-row">
              <span>🔒</span>
              <div>
                <div className="pd-trust-title">Secure Booking</div>
                <div className="pd-trust-sub">100% refund if visit unsatisfied</div>
              </div>
            </div>
            <div className="pd-trust-row">
              <span>📋</span>
              <div>
                <div className="pd-trust-title">Easy Agreement</div>
                <div className="pd-trust-sub">Digital rent agreement included</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
